const PKCE_VERIFIER_KEY = "pkce_verifier";

function base64UrlEncode(arrayBuffer) {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = "";
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

function generateRandomVerifier(length = 64) {
  // RFC 7636 allows 43..128 chars, using URL-safe charset
  const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  const random = new Uint8Array(length);
  crypto.getRandomValues(random);

  let verifier = "";
  for (let i = 0; i < random.length; i++) {
    verifier += charset[random[i] % charset.length];
  }
  return verifier;
}

async function sha256(input) {
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  return crypto.subtle.digest("SHA-256", data);
}

export async function createPkcePair() {
  const codeVerifier = generateRandomVerifier(64);
  const digest = await sha256(codeVerifier);
  const codeChallenge = base64UrlEncode(digest);

  return {
    codeVerifier,
    codeChallenge,
  };
}

export function storePkceVerifier(verifier) {
  sessionStorage.setItem(PKCE_VERIFIER_KEY, verifier);
}

export function readPkceVerifier() {
  return sessionStorage.getItem(PKCE_VERIFIER_KEY);
}

export function clearPkceVerifier() {
  sessionStorage.removeItem(PKCE_VERIFIER_KEY);
}
